import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import LogInModal from "flarum/components/LogInModal";
import SignUpModal from "flarum/components/SignUpModal";

export default class UserComponent extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.userData = app.session.user;
  }

  oncreate(vnode) {
    super.oncreate(vnode);
  }

  view() {
    if(this.userData===null){
      return (
        <div className="u2diSubmitButtonContainer">
          {Button.component({
              className: 'Button Button--primary u2diUserLoginButton',
              onclick: () => {
                app.modal.show(LogInModal);
              }
            },
            app.translator.trans('ziven-u2di.forum.button-login')
          )}
          {Button.component({
              className: 'Button u2diUserRegisterButton',
              onclick: () => {
                app.modal.show(SignUpModal);
              }
            },
            app.translator.trans('ziven-u2di.forum.button-register')
          )}
        </div>
      );
    }else{
      
    }
  }

}